/* eslint-disable react/prefer-stateless-function */

import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// actions
import { passwordResetClear, passwordResetUpdate } from '../../actions/passwordResetActions';

// components
import { Link } from 'react-router';
import { Button } from '../shared/_form';
import { SimplePanel } from '../shared/_panel';

// lib
import handleFormChange from '../../lib/handleFormChange';

class Edit extends React.Component {
  static propTypes = {
    passwordReset: PropTypes.instanceOf(Immutable.Map)
  }

  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map() };
  }

  componentWillUnmount() {
    this.props.dispatch(passwordResetClear());
  }

  render() {
    const { passwordReset } = this.props;

    const loading = passwordReset.get('loading');

    return (
      <div className='body__content body__content--center'>
        <SimplePanel header='Password Reset'>
          { this._renderMessage() }
          <div className='password-reset__form'>
            <form onSubmit={ this._handleSubmit }>
              <input className='form__field form__field--rounded'
                name='password'
                onChange={ handleFormChange(this) }
                placeholder='Password'
                type='password' />
              <input className='form__field form_field--edit form__field--rounded'
                name='confirmPassword'
                onChange={ handleFormChange(this) }
                placeholder='Password Confirmation'
                type='password' />
              <div className='password-reset__form__submit'>
                <Button className='form__button--green' loading={ loading }>Reset Your Password</Button>
                <Link className='password-reset__form__back-to-login' to='/login'>Back to login</Link>
              </div>
            </form>
          </div>
        </SimplePanel>
      </div>
    );
  }

  _handleSubmit = this._handleSubmit.bind(this);

  _handleSubmit(e) {
    e.preventDefault();

    const form = this.state.data.get('form');

    const token                = this.props.params.token;
    const password             = form.password;
    const passwordConfirmation = form.confirmPassword;

    this.props.dispatch(passwordResetUpdate(token, password, passwordConfirmation));
  }

  _renderMessage() {
    let inner;

    const { passwordReset } = this.props;

    const status = passwordReset.get('status');

    if (status === 'success') {
      inner = 'Your password has been reset';
    } else if (status === 'error') {
      inner = 'Please make sure both password and password confirmation are the same';
    }

    return (
      <div className='panel__form__error'>
        { inner }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    passwordReset: state.get('passwordReset')
  };
};

export default connect(mapStateToProps)(Edit);



// WEBPACK FOOTER //
// ./app/components/password_resets/Edit.jsx